import React, { useEffect, useState } from "react"
import { useTransition, config } from "react-spring"

import { Slide } from "./styles"

const Slider = ({ slides, delay }) => {
  const duration = 4000
  const [index, set] = useState(0)
  const transitions = useTransition(slides[index], item => item.id, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.molasses,
  })
  useEffect(
    () =>
      void setTimeout(
        () =>
          setInterval(() => set(state => (state + 1) % slides.length), duration),
        delay
      ),
    []
  )
  return transitions.map(({ item, props, key }) => (
    <Slide
      key={key}
      style={{ ...props, backgroundImage: `url(${item.publicURL})` }}
    />
  ))
}

Slider.defaultProps = {
  delay: 0,
}

export default Slider
